/**
 * 코스 프리셋 표시 — ModeDefinition.presets[].titleKey 는 셸 카탈로그 키다(계약). 실제 모드 정의(libs/modes)는
 * `mode.obstacleCourse.<key>` 를 쓰는데 셸 카탈로그에 아직 없으면 `course.preset.<key>` 로 대신한다.
 * 요약('계단+언덕')은 summaryKey(가짜 모드) → 없으면 env 프리팹의 표면을 순서대로 모아 만든다(언덕 · 계단 · 다리).
 */
import type { Translate } from "../../../i18n";
import type { Preset } from "../types";

const has = (t: Translate, key: string) => t(key) !== key;

export function presetTitle(t: Translate, p: Preset): string {
  if (p.titleKey && has(t, p.titleKey)) return t(p.titleKey);
  const k = `course.preset.${p.key}`;
  return has(t, k) ? t(k) : p.key;
}

const OBSTACLE: Record<string, string> = {
  ramp: "ramp",
  step: "step",
  bridge: "bridge",
  line: "line",
  grass: "grass",
};

export function presetSummary(t: Translate, p: Preset): string {
  if (typeof p.summaryKey === "string" && has(t, p.summaryKey)) return t(p.summaryKey);
  const env = Array.isArray(p.env) ? (p.env as { prefab?: string; surface?: string }[]) : [];
  const kinds: string[] = [];
  for (const e of env) {
    const k = OBSTACLE[e.surface ?? e.prefab ?? ""];
    if (k && !kinds.includes(k)) kinds.push(k);
  }
  return kinds.map((k) => t(`run.surface.${k}`)).join("+");
}
